export const GET_ALL_GAMES_FOR_EXTERNAL_USERS = 'GET_ALL_GAMES_FOR_EXTERNAL_USERS';
export const RESET_ALL_GAMES_FOR_EXTERNAL_USERS = 'RESET_ALL_GAMES_FOR_EXTERNAL_USERS';

export const GET_EXTERNAL_USERS_START = 'GET_EXTERNAL_USERS_START';
export const GET_EXTERNAL_USERS_SUCCESS = 'GET_EXTERNAL_USERS_SUCCESS';
export const GET_EXTERNAL_USERS_FAIL = 'GET_EXTERNAL_USERS_FAIL';

export const EXTERNAL_USER_ACTION_START = 'EXTERNAL_USER_ACTION_START';
export const EXTERNAL_USER_ACTION_SUCCESS = 'EXTERNAL_USER_ACTION_SUCCESS';
export const EXTERNAL_USER_ACTION_FAIL = 'EXTERNAL_USER_ACTION_FAIL';